import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
// import rootReducer from "../modules";
export default (name: string, rootReducer: any, json = {}) => {
    const enhancers = [];
    if (!__SERVER__ && process.env.NODE_ENV === 'development') {
        const __REDUX_DEVTOOLS_EXTENSION__ = window.__REDUX_DEVTOOLS_EXTENSION__;
        if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
            enhancers.push(__REDUX_DEVTOOLS_EXTENSION__());
        }
    }
    const middleware = [thunk];
    const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
    const stateKey = `__PRELOADED_STATE_${name}__` as keyof Window;
    const initialState = !__SERVER__ && window[stateKey]
        ? window[stateKey]
        : Object.assign({}, json);
    if (!__SERVER__) {
        delete window[stateKey];
        const script = document.getElementById(`${name}-script`);
        if (script) {
            script.innerHTML = '';
        }
    }
    const store = createStore(rootReducer, initialState, composedEnhancers);
    return { store };
};
